export default __webpack_public_path__ + "static/register-1e3281dedec8be0d4e1a4229f3516150.png";